import * as React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import styled from 'styled-components';
import { Input } from 'reactstrap';

const StyledSearchBarContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  color: #464444;
`;

const StyledSearchBarInputContainer = styled.div`
  position: relative;

  span {
    font-weight: 700;
    font-size: 11px;
    color: #828282;
    margin-left: 16px;
  }

  input {
    padding-left: 16px;
    padding-bottom: 10px;
  }
`;

const StyledSearchBarInput = styled(Input)`
  border: none !important;
  outline: none;
  box-shadow: none !important;

  :focus {
    outline: none !important;
  }
`;

const StyledAutoCompleteContainer = styled.div`
  width: 100%;
  position: absolute;
  z-index: 1;
`;

const StyledSuggestionItem = styled.div`
  padding: 8px;
  padding-left: 16px;
  text-align: left;
  cursor: pointer;
  background-color: #ffffff;
  border: 1px solid #f2f2f2;
  margin-top: -1px;
`;

interface props {
  InputTitleText: string;
  InputPlaceholderText: string;
  address?: string;
  onChange?: ((value: string) => void);
}

interface state {
  address: string;
  errorMessage: string;
}

class LocationSearchInput extends React.Component<props, state> {
  state = {
    address: this.props.address == null ? '' : this.props.address,
    errorMessage: '',
  };

  constructor(props: any) {
    super(props);
  }

  handleChange = (address: string) => {
    this.props.onChange && this.props.onChange(address);
    this.setState({ address });
  };

  handleSelect = (address: string) => {
    this.props.onChange && this.props.onChange(address);
    this.setState({ address });
  };

  handleError = (status: any, clearSuggestions: any) => {
    console.log('Error from Google Maps API', status); // eslint-disable-line no-console
    this.setState({ errorMessage: status }, () => {
      clearSuggestions();
    });
  };

  render() {
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        handleError={this.handleError}
      >
        {({
          getInputProps,
          suggestions,
          getSuggestionItemProps,
        }: {
          getInputProps: any;
          suggestions: any;
          getSuggestionItemProps: any;
          loading: any;
        }) => (
          <StyledSearchBarContainer>
            <StyledSearchBarInputContainer>
              <span>{this.props.InputTitleText}</span>
              <StyledSearchBarInput
                {...getInputProps({
                  placeholder: this.props.InputPlaceholderText,
                })}
              />
              <StyledAutoCompleteContainer>
                {suggestions.map((suggestion: any) => {
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                  return (
                    <StyledSuggestionItem
                      {...getSuggestionItemProps(suggestion, {
                        style,
                      })}
                    >
                      {suggestion.formattedSuggestion.mainText},{' '}
                      {suggestion.formattedSuggestion.secondaryText}
                    </StyledSuggestionItem>
                  );
                })}
              </StyledAutoCompleteContainer>
            </StyledSearchBarInputContainer>
          </StyledSearchBarContainer>
        )}
      </PlacesAutocomplete>
    );
  }
}

export default LocationSearchInput;



// WEBPACK FOOTER //
// ./src/components/FormComponents/LocationSearchInput.tsx